export default __webpack_public_path__ + "static/real-time-edit-5787253bdf6dc1d72a0d8c7b194bf086.png";